import script from "./LegalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalPage.vue?vue&type=script&setup=true&lang=js"

import "./LegalPage.vue?vue&type=style&index=0&id=473a06df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473a06df"]])

export default __exports__